import script from "./PageTabTitle.js?vue&type=script&lang=js"
export * from "./PageTabTitle.js?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__